import { TableCell, TableSortLabel } from "@mui/material";
import type { EvidenceActivityDir } from "../../types/evidenceActivity";

const headSx = { fontSize: 11, fontWeight: 500, color: "text.secondary", textTransform: "uppercase", letterSpacing: "0.05em", whiteSpace: "nowrap" } as const;

interface Props {
  label: string;
  active: boolean;
  dir: EvidenceActivityDir;
  onClick: () => void;
  align?: "left" | "right";
}

export default function SortHeader({ label, active, dir, onClick, align = "left" }: Props) {
  return (
    <TableCell align={align} sortDirection={active ? dir : false} sx={headSx}>
      <TableSortLabel active={active} direction={active ? dir : "desc"} onClick={onClick} sx={{ "&.Mui-active": { color: "text.primary" } }}>
        {label}
      </TableSortLabel>
    </TableCell>
  );
}
